import { AccountLayout, AuthenticatedLayout } from "../../layouts";

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { SecurityQuestionsScreen } from "../../components/SecurityQuestionsScreen";

export const SecurityQuestionsScreenPage = () => {
  return (
    // <AuthenticatedLayout
    //   pageTitle="Answer the Questions"
    //   pageTitleIcon={<DescriptionOutlinedIcon />}
    //   breadcrumbCurrentPageName=""
    //   breadcrumbLinks={[
    //     { text: "Answer the Questions", navigateTo: "#" }
    //   ]}
    //   mainContents={<SecurityQuestionsScreen />}
    // />
    <AccountLayout
      contents={<SecurityQuestionsScreen />}
      contentColumns={4}
    />
  );
};
